import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateAgrNotificationController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
function CreateAggNotification({ agreement, onClose, onSuccess, AgreementID }) {
    const { t } = useTranslation(); // Initialize the useTranslation hook
    const [formData, setFormData] = useState({ AgreementID: AgreementID, vc_Email: "", vc_Other: "" });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") { // Corrected the comparison operator
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (agreement) {
            setFormData({ vc_Email: agreement.vc_Email, vc_Other: agreement.vc_Other });
        } else {
            setFormData({ vc_Email: '', vc_Other: "" }); // Clear form data when switching to add mode
        }
    }, [agreement]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (agreement) {
            formData.ID = agreement.PK_ContractNotifications_ID;
        } else {
            formData.ID = 0;
        }
        formData.FK_Contract_ID = AgreementID;
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate(`/AgreementDetail?ID=${AgreementID}`);
        };

        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess(); // Call onSuccess to reload data

        }, () => {
            onSuccess(); // Call onSuccess to reload data
        });
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade agreementNotificationModal show d-block" id="agreementNotificationModal" tabIndex="-1" aria-labelledby="agreementNotificationModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{agreement ? "Edit Notification" : "Add Notification"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginRight: "5px", marginTop: "10px" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>


                                                <tr>
                                                   <td style={{width:"13%"}}> <label htmlFor="inputText" style={{ float: "right" }}>Email &nbsp;&nbsp;</label></td>
                                                    <td style={{width:"37%"}}>
                                                        <input type="text" className="form-control" name="vc_Email" value={formData.vc_Email} onChange={handleFieldChange} />
                                                        {errors.vc_Email && <div style={{ color: 'red' }}>{errors.vc_Email}</div>}
                                                    </td>
                                                   <td style={{width:"13%"}}> <label htmlFor="inputText" style={{ float: "right" }}>Name &nbsp;&nbsp;</label> {/* Utilize translation for the label */}</td>
                                                    <td style={{width:"37%"}}>
                                                        <input type="text" className="form-control" name="vc_Other" value={formData.vc_Other} onChange={handleFieldChange} />
                                                        {errors.vc_Other && <div style={{ color: 'red' }}>{errors.vc_Other}</div>}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  {agreement ? " Update" : " Save"}
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateAggNotification;
